import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { usePlace } from 'commons/usePlace'

export const useUserProfile = () => useSelector(R.path(userProfilePath))
export const useUserProfileLocalizationLanguage = () =>
  useSelector(R.path(userProfileLocalizationLanguagePath))
export const userProfilePath = ['auth', 'user', 'data']
export const userProfileLocalizationLanguagePath = [
  'auth',
  'user',
  'data',
  'localizationLanguage',
]

export const useIsRootAdmin = () => {
  const place = usePlace()
  return (userId) => place.creatorId === userId
}
